import actions from '@/store/modules/industry/actions.js'
import state from '@/store/modules/industry/state.js'
import mutations from '@/store/modules/industry/mutations.js'
import getters from '@/store/modules/industry/getters.js'
import cloneDeep from 'lodash/cloneDeep'

export default {
  actions,
  state: cloneDeep(state),
  mutations,
  getters,
}
